// ULID generator (Crockford base32, 48-bit time + 80-bit randomness) for X-Request-Id and Idempotency-Key.
const ALPHABET = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";
const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/;

export function ulid(now: number = Date.now()): string {
  let time = now;
  let t = "";
  for (let i = 0; i < 10; i++) { t = ALPHABET[time % 32] + t; time = Math.floor(time / 32); }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  let r = "";
  for (let i = 0; i < 16; i++) r += ALPHABET[bytes[i]! % 32];
  return t + r;
}

export const isUlid = (s: string): boolean => ULID_RE.test(s);
